import type { AllRouteEndpoints } from "../routeTypes";

export const analyticsDashboardAppGroupIdEmailEngagementByDeviceClassData =
  "/analytics_dashboard/:app_group_id/email_engagement_by_device_class_data";

export const analyticsDashboardAppGroupIdEmailEngagementByDeviceClassDataCacheKeys: AllRouteEndpoints[] = [];
